module.exports = __webpack_public_path__ + "static/media/hackathon.16fd5474.jpeg";